"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureToggle = void 0;
var react_1 = __importDefault(require("react"));
var context_1 = require("./context");
var FeatureToggle = function (_a) {
    var name = _a.name, displayName = _a.displayName, _b = _a.alternativeContent, alternativeContent = _b === void 0 ? null : _b, children = _a.children;
    var _c = react_1.default.useContext(context_1.FeatureToggleContext), registerFeature = _c.registerFeature, isFeatureEnabled = _c.isFeatureEnabled, features = _c.features;
    react_1.default.useEffect(function () {
        registerFeature(name, displayName || name);
    }, [name, displayName, registerFeature]);
    var isEnabled = (features[name] && features[name].isEnabled) || isFeatureEnabled(name);
    return (isEnabled && children) || alternativeContent;
};
exports.FeatureToggle = FeatureToggle;
